import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'translations';
import { connect } from 'react-redux';
import reduxUtils from 'util/redux';

const NoSearchHits = ({ isSearching }) => {
    if (isSearching) {
        return null;
    }
    return (
        <div className="search-panel-no-hits">
            <Trans path="search.no_hits" />
        </div>
    );
};

NoSearchHits.propTypes = {
    isSearching: PropTypes.bool.isRequired,
};

export default connect(
    reduxUtils.mapStateToProps({
        isSearching: 'search.isSearching',
    }),
    reduxUtils.mapDispatchToProps({})
)(NoSearchHits);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/main-header/search/search-panel-no-hits/index.js